// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dKdrH","expireSoon":"styles_expireSoon__2T_zG"};